import React, { FC, useMemo, useState } from "react";
import { Button, Table, message, Upload, notification } from "antd";
import { YhBox } from "@/components/YhBox";
import { IMaterialDetailModel, useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { IMaterialDetailList } from "../../maintenanceType";
import { formatIntPoint, repairFormatNum, formatIntPoint1, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import { DetailType, IServiceNatureCodeType, IPriceTypeEnum } from "@/types/ScmEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { ITopType } from "@/types/ScmTypes";
import { YhBut } from "@/components/YhButton";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { importPropsConfig } from "@/utils/importFile";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { useSaleSoDetailModel } from "@/views/sale/so/view/details/saleSoDetailModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import { useDictModel } from "@/views/base/dict/dictModel";
import { PictureOutlined } from "@ant-design/icons";
import { LookPictureModal } from "@/views/lookPicture";

export const MaterialTableBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const { shopAndOrg: { shopId }, user: { roles }, setLoadingInfo } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        SBcode,
        isThreeService,
        detailAddForm,
        detailEditForm,
        setMaterialModel,
        detailMaterialAddList, setDetailMaterialAddList,
        detailMaterialAddDataRowKeys, setDetailMaterialAddDataRowKeys,
        setDetailMaterialAddDataRow,
        detailMaterialEditList, setDetailMaterialEditList,
        detailMaterialEditDataRowKeys, setDetailMaterialEditDataRowKeys,
        setDetailMaterialEditDataRow,
        detailMaterialLookList,
        detailMaterialDetailList,
        setTopButsControl,
        setHistoryVisible,
        setHistoryRow,
        transformsToPoMaterialDetailList
    } = useMaintenanceDetailsModel();
    let { priceTypeCode, serviceNatureCode, customerCode, status } = mode === "add" ? detailAddForm : detailEditForm;
    const { downloadTpl } = useSaleSoDetailModel()

    // 计算维修用料的总金额和项数
    const currentMaterialList = mode === "add" ? detailMaterialAddList : detailMaterialEditList;
    const materialTotalAmount = currentMaterialList.filter((item) => item.threeGuaranteesId == SBcode).reduce((sum, item) => sum + (Number(item.receivableAmount) || 0), 0);
    const materialCount = currentMaterialList.filter((item) => item.threeGuaranteesId == SBcode).length;

    const title = <>
        <span>维修用料</span>
        {isThreeService && <span style={{
            color: '#4062d8',           // 辅助文字颜色
            fontSize: '15px',
            fontWeight: '500',
            lineHeight: 1.5,
            marginLeft: '30px',
        }}>总金额
            <span style={{
                color: '#ff615a',        // 金额数字强调色
                fontWeight: 'bold',
                fontSize: '20px',        // 放大金额数字
                margin: '0 6px'       // 与“总金额”稍留间距
            }}>
                ¥ {repairFormatNum(materialTotalAmount)}
            </span>
            元
            ( <span style={{
                color: '#ff615a',        // 项数字同样强调
                fontWeight: 'bold'
            }}>{materialCount}</span> 项 )
        </span>}
    </>

    const onHistoryModel = (record: IMaterialDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const switchModelViaible = () => {
        IFormRef.current?.validateFields().then(async res => {
            if (mode === "add") {
                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailAddForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                if (!(customerCode && customerName && payType && settlementPartyCode)) {
                    message.warning("请补全客户名称或结算类型或结算方")
                    return false
                }
                //     let { accountName, availableAmount, isBill, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });

                //     if (payType !== IVRMSettleTypeEnum.SETTLE_CASH) {
                //         if (accountName && availableAmount > 0) {
                //             materialTips(`当前${accountName},授信额度为${availableAmount},是否确认？？`, true)
                //         } else if (accountName && availableAmount === 0) {
                //             materialTips(`当前${accountName},授信额度为${availableAmount}，不可开单，是否确认？？`, false)
                //         } else if (!accountName) {
                //             materialTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                //         }
                //     } else {
                //         setMaterialModel(true)
                //     }
                // } else {
                setMaterialModel(true)
            } else {
                setMaterialModel(true)
            }
        })
    }
    const materialTips = (info: string, visible: boolean) => {
        globalPrompt("modal", {
            title: "新增维修项目",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { visible && await setMaterialModel(visible) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const importCallback = async (list: IMaterialDetailModel[]) => {
        if (!list) return;
        let newImportList = await Promise.all(list?.map(async (item: any) => {
            let { latestPurPriceNew, stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, petroleumPrice, purchasePrice, retailPrice, num, price, ...params } = item as { latestPurPriceNew: number, latestPurPrice: number, lateSalePrice: number, purchasePrice: number, petroleumPrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string, price: number }
            let newPrice: number = latestPurPrice ?? purchasePrice;
            if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
                if (priceTypeCode) {
                    switch (priceTypeCode) {
                        //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                        case IPriceTypeEnum.CUSTOMER_LATEST:
                            let { retData: { price: recentPrice } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                            newPrice = +recentPrice;
                            break;
                        //售价选择 最近销价 
                        case IPriceTypeEnum.RECENT:
                            newPrice = lateSalePrice ?? retailPrice;
                            break;
                        //售价选择 零售价
                        case IPriceTypeEnum.RETAIL:
                            newPrice = retailPrice > price ? retailPrice : price;
                            break;
                        //最新采购价
                        case IPriceTypeEnum.LATEST_PURCHASE:
                            newPrice = latestPurPriceNew > price ? latestPurPriceNew : price;
                            break;
                        //售价选择 采购成本价
                        case IPriceTypeEnum.PUR_COST:
                            newPrice = latestPurPrice ?? purchasePrice;
                            break;
                        //售价选择 档案进价
                        case IPriceTypeEnum.BUYING_PRICE:
                            newPrice = purchasePrice ?? latestPurPrice;
                            break;
                        //售价选择 石油价格
                        case IPriceTypeEnum.PETROLEUM:
                            newPrice = petroleumPrice ?? purchasePrice
                            break;
                    }
                } else {
                    return
                }
            }
            return {
                ...item,
                id: stockId,
                num,
                price: newPrice,
                latestPurPrice: item.price,
            }
        }) ?? [])
        transformsToPoMaterialDetailList(mode, newImportList)
    }
    const upLoadCallback = (list: any) => {
        setLoadingInfo({ loadingVisible: false, txt: '' })
        if (list && list.length) {
            let str = ""
            let newData: any = []
            list.map((lists: any, index: any) => {
                if (lists.status) {
                    lists.details.map(async (item: any) => {
                        let { latestPurPriceNew, stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, petroleumPrice, purchasePrice, retailPrice, num, price, ...params } = item as { latestPurPriceNew: number, latestPurPrice: number, lateSalePrice: number, purchasePrice: number, petroleumPrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string, price: number }
                        let newPrice: number = latestPurPrice ?? purchasePrice;
                        if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
                            if (priceTypeCode) {
                                switch (priceTypeCode) {
                                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                                    case IPriceTypeEnum.CUSTOMER_LATEST:
                                        purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string).then(({ retData }) => {
                                            newPrice = +retData.price;
                                        })
                                        break;
                                    //售价选择 最近销价 
                                    case IPriceTypeEnum.RECENT:
                                        newPrice = lateSalePrice ?? retailPrice;
                                        break;
                                    //售价选择 零售价
                                    case IPriceTypeEnum.RETAIL:
                                        newPrice = retailPrice > price ? retailPrice : price;
                                        break;
                                    //最新采购价
                                    case IPriceTypeEnum.LATEST_PURCHASE:
                                        newPrice = latestPurPriceNew > price ? latestPurPriceNew : price;
                                        break;
                                    //售价选择 采购成本价
                                    case IPriceTypeEnum.PUR_COST:
                                        newPrice = latestPurPrice ?? purchasePrice;
                                        break;
                                    //售价选择 档案进价
                                    case IPriceTypeEnum.BUYING_PRICE:
                                        newPrice = purchasePrice ?? latestPurPrice;
                                        break;
                                    //售价选择 石油价格
                                    case IPriceTypeEnum.PETROLEUM:
                                        newPrice = petroleumPrice ?? purchasePrice
                                        break;
                                }
                            } else {
                                return
                            }
                        }
                        newData.push({
                            ...item,
                            id: stockId,
                            num,
                            price: newPrice,
                            latestPurPrice: item.price,
                        })
                    })
                }
                else {
                    str += `【第${index + 1}条导入失败：${lists.msg}】`;
                }
            })
            transformsToPoMaterialDetailList(mode, newData)
            str ? notification.warning({ message: '提醒', description: str, duration: 9 }) : message.success("导入成功")
        }
    }
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && (detailEditForm.status === DictCodeEnmu.MAINTENANCE_COMPLETED || detailEditForm.status === DictCodeEnmu.MAINTENANCE_STATUS_FINAL || detailEditForm.status === DictCodeEnmu.MAINTENANCE_SETTLE || detailEditForm.status === DictCodeEnmu.MAINTENANCE_UNDER_REVIEW || detailEditForm.status === "maintenance-status.paying")) {
            return false;
        }
        return true;
    }
    const action = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.M_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                    onClick={() => switchModelViaible()}
                >新增商品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_DEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                    onClick={() => detailMaterialDetailList(mode)}
                >删除商品</Button>
            </YhAuth>
            {!isThreeService && <> <YhAuth resCode={ResourceAuthEnum.S_S_ED_IM}>
                <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/sale/details/importPro`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "正在导入中" }), { shopId }, false)}>
                    <Button
                        disabled={!(serviceNatureCode && customerCode)}
                        className="mr-5"
                        type="primary"
                        shape="round">导入</Button>
                </Upload>
            </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_DLOAD}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={downloadTpl}
                    >下载模板</Button>
                </YhAuth></>}
        </>}
    </>;
    const removeMaterial = (record: IMaterialDetailList) => {
        detailMaterialDetailList(mode, record)
    }
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [currentMaterialCode, setCurrentMaterialCode] = useState("");
    const handleOpenImageModal = (materialCode: string) => {
        setCurrentMaterialCode(materialCode);
        setImageModalVisible(true);
    };
    const handleCloseImageModal = () => {
        setImageModalVisible(false);
        setCurrentMaterialCode("");
    };
    const { getTreeNodeName } = useDictModel();
    const materialColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 140,
            dataIndex: 'materialCode',
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
            sorter: {
                compare: (a: { materialCode: string; }, b: { materialCode: string; }) => {
                    if (a.materialCode.charCodeAt(0) == b.materialCode.charCodeAt(0)) {
                        return a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0)
                    }
                    return a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0)
                },
                multiple: 1,
            },
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <YhTootip text={text} onClick={() => onHistoryModel(record)} style={{ maxWidth: "130px" }} />
                    <PictureOutlined
                        style={{ color: '#009688', cursor: 'pointer', marginLeft: 4, fontSize: '22px' }}
                        onClick={() => handleOpenImageModal(record.materialCode)} // 点击打开图片模态框
                    />
                </div>
            ),
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '状态',
            width: 100,
            align: "center",
            dataIndex: "status",
            render: (text: any) => text ? getTreeNodeName(text) : "备料前"
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: isMaterialModel()
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: isMaterialModel(),
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '配件费',
            width: 100,
            dataIndex: 'materialAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '库房',
            width: 140,
            dataIndex: 'warehouseName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            editable: isMaterialModel(),
            render: (text: string) => text + "%"
        },
        {
            title: '折后金额',
            width: 100,
            dataIndex: 'discountedAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '单项优惠金额',
            width: 160,
            dataIndex: 'decreaseAmount',
            editable: isMaterialModel(),
            render: (text: any) => `￥${formatNum(text)}`
        },
        {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
            render: (text: any) => text < 0 ? `-￥${formatNum(text)}` : `￥${formatNum(text)}`
        }, {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: isMaterialModel()
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isMaterialModel() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />
        }
    ];

    const typeMaterialList = {
        "add": [...detailMaterialAddList],
        "edit": [...detailMaterialEditList],
        "look": [...detailMaterialLookList],
    }

    const newSelectMaterialColums = () =>
        materialColumns.map((col: any, index) => {
            //已结算 已完工  审核中 审核通过  在修状态下 明细是出库状态的 不可以进行数量编辑
            let numEditable = !!(status !== DictCodeEnmu.MAINTENANCE_STOCK_IO && status !== DictCodeEnmu.MAINTENANCE_COMPLETED && status !== DictCodeEnmu.MAINTENANCE_STATUS_FINAL && status !== DictCodeEnmu.MAINTENANCE_SETTLE && status !== DictCodeEnmu.MAINTENANCE_APPROVED && status !== DictCodeEnmu.MAINTENANCE_UNDER_REVIEW)
            return {
                ...col,
                onCell: (record: IMaterialDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col?.editType,
                    suffix: col.suffix,
                    editable: col.dataIndex === 'num' ? (numEditable && record.status !== "details.preparation.ware.out") : col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "order", "roleCodes": roles };
        return getRoleColumns("order", "维修用料", newSelectMaterialColums(), params);
    }, [roles, typeMaterialList[mode], materialColumns]);
    const handleMaterialSave = (row: IMaterialDetailList) => {
        let { num, price, discountRate, inventoryNum, purchasePrice, latestPurPrice, termNum, decreaseAmount, discountedAmount, receivableAmount } = row;
        const newServiceNatureCode = mode === "add" ? detailAddForm.serviceNatureCode : detailEditForm.serviceNatureCode;
        const newOrderType = mode === "add" ? detailAddForm.orderType : detailEditForm.orderType;
        // 三包类型：默认使用latestPurPrice，且不能低于purchasePrice
        if (newOrderType === 'maintenanceOrder-type.threeService') {
            price = price;
            price = +formatIntPoint1(price, latestPurPrice, `修改价格不应小于采购价${latestPurPrice}`);
        } else {
            price = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN ?
                +formatIntPoint1(price, latestPurPrice, `修改价格不应小于进货价${latestPurPrice}`) : newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ?
                    +repairFormatNum(price) : +formatIntPoint1(price, latestPurPrice, `修改价格不应小于进货价${latestPurPrice}`)
        }
        num = mode === "add" ? +formatIntPoint(num, inventoryNum, "选择数量>=可用库存数量") : +formatIntPoint(num, termNum ? termNum : inventoryNum, "选择数量>=可用库存数量");  //数量
        discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%');  //折扣
        let newPrice = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? price : +formatNum(price)
        // 折后金额
        discountedAmount = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * newPrice * discountRate) / 100) : +formatNum((num * newPrice * discountRate) / 100)
        // decreaseAmount = +formatIntPoint(decreaseAmount, 1, '单项优惠金额不能大于1元')
        // 小计
        receivableAmount = +formatNum(discountedAmount - decreaseAmount)
        let newRow = {
            ...row,
            num: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num) : +formatNum(num),
            price: newPrice,
            discountRate,
            materialAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num * newPrice) : +formatNum(num * newPrice),
            decreaseAmount,
            discountedAmount,
            receivableAmount
        }

        let newData = mode === "edit" ? detailMaterialEditList : detailMaterialAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailMaterialEditList([...newData]) : setDetailMaterialAddList([...newData])
        setTopButsControl(true)
    }

    //设置维修用料选中的行和数据
    const setTypeMaterialDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeMaterialDetailDataRow = async (selectedRows: IMaterialDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRow(selectedRows)
        }
    }

    return (
        <YhBox title={title} rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns}
                dataSource={isThreeService ? typeMaterialList[mode].filter((item) => item.threeGuaranteesId == SBcode) : typeMaterialList[mode]}
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailMaterialAddDataRowKeys : detailMaterialEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetailList[]) => {
                            setTypeMaterialDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 350 }}
            />
            <LookPictureModal
                visible={imageModalVisible}
                materialCode={currentMaterialCode}
                onClose={handleCloseImageModal}
            />
        </YhBox>
    )
}